/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShareAfterDiscounts/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ShareAfterDiscounts({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Payors/Payor/ShareAfterDiscounts"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let payorValueData = fromData.useDataValue({ viewPath,
context: 'payor',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData = fromHelpers.getPayorShareAfterDiscountsFormatted(payorValueData, paymentPlanValueData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="ShareAfterDiscounts.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZPpVwG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-2-ZPpVwG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-ZPpVwG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-ZPpVwG': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 flexGrow={1}
 flexShrink={1}
 flexBasis={0}
 text="Amount to pay"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor"
 data="payment_plan"
 aggregate="helpers.js getPayorShareAfterDiscountsFormatted"
 text={aggregateData}
 weight="medium"
 color={dtColorsBlack}
 marginLeft={dtSpaceS}
/>
</div>
{children}
</React.Fragment>)
}